import { useTranslation } from 'react-i18next'

import { Button, Drawer } from '@reveni-io/reveni-ui'

import { selectDropOffPointTitle } from '../constants'
import { supportsDropOffPointSelection } from '../helpers'
import DropOffPointList from './DropOffPointList/DropOffPointList'
import Header from './Header/Header'
import useDropOffPointDrawer from './hooks/useDropOffPointDrawer/useDropOffPointDrawer'
import SearchAddressInfo from './SearchAddressInfo/SearchAddressInfo'
import UpdateSearchAddressDrawer from './UpdateSearchAddressDrawer/UpdateSearchAddressDrawer'
import { getSearchAddress } from './helpers'
import * as Styles from './styles'

const DropOffPointDrawer = ({
  show,
  orderId,
  returnId,
  deliveryMethod,
  shippingAddress,
  selectedDropOffPoint,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation()
  const {
    searchAddress,
    showUpdateAddressDrawer,
    pickedDropOffPoint,
    dropOffPoints,
    searching,
    canConfirm,
    pickDropOffPoint,
    openUpdateAddressDrawer,
    closeUpdateAddressDrawer,
    updateSearchAddress,
  } = useDropOffPointDrawer({ show, orderId, returnId, deliveryMethod, shippingAddress, selectedDropOffPoint })

  const handleConfirm = () => {
    onConfirm(pickedDropOffPoint)
  }

  if (!supportsDropOffPointSelection(deliveryMethod)) return null

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false, useBlurForBackdrop: true }}>
      <Styles.Container>
        <Header title={t(selectDropOffPointTitle)} onBack={onClose} />
        <SearchAddressInfo address={getSearchAddress(searchAddress)} onChangeAddress={openUpdateAddressDrawer} />
        <DropOffPointList
          dropOffPoints={dropOffPoints}
          searching={searching}
          selectedDropOffPoint={pickedDropOffPoint}
          onSelect={pickDropOffPoint}
        />
        <Button onClick={handleConfirm} disabled={!canConfirm} fullWidth>
          {t('Confirmar selección')}
        </Button>
      </Styles.Container>
      <UpdateSearchAddressDrawer
        show={showUpdateAddressDrawer}
        searchAddress={searchAddress}
        onUpdate={updateSearchAddress}
        onClose={closeUpdateAddressDrawer}
      />
    </Drawer>
  )
}

export default DropOffPointDrawer
